import React from 'react';
import { DashboardTemplate } from './shared';
import { enrollmentConfig, mockEnrollmentData } from './configs/enrollment-config';
import { mergeDataWithFallback } from '../../../utils/dataFallback';

function EnrollmentData({ report = {}, loading = false }) {
    // Only use mock data when not loading (to avoid showing mock data before API response)
    const dataWithMock = loading ? report : mergeDataWithFallback(report, mockEnrollmentData);
    
    return (
        <DashboardTemplate 
            title={enrollmentConfig.title}
            topKPIs={enrollmentConfig.topKPIs}
            charts={enrollmentConfig.charts}
            bottomKPIs={enrollmentConfig.bottomKPIs}
            report={dataWithMock}
            loading={loading}
        />
    );
}

export default EnrollmentData;
